import { App } from '@capacitor/app';
import { isNativePlatform } from './platformService.js';

const SUPPORTED_PATH_PREFIXES = [
  '/signin',
  '/courses',
  '/assessments',
  '/learn',
  '/coaching',
  '/library',
  '/notifications',
  '/account',
  '/paymentsuccess',
  '/paymentfailure',
  '/paymentprocess',
];

export function normalizeDeepLinkPath(url) {
  try {
    const parsed = new URL(url);
    const path = `${parsed.pathname}${parsed.search}${parsed.hash}`;
    if (SUPPORTED_PATH_PREFIXES.some((prefix) => parsed.pathname === prefix || parsed.pathname.startsWith(`${prefix}/`))) {
      return path || '/courses';
    }
  } catch {
    if (SUPPORTED_PATH_PREFIXES.some((prefix) => url === prefix || url.startsWith(`${prefix}/`))) {
      return url;
    }
  }
  return null;
}

export function listenForDeepLinks(history) {
  if (!isNativePlatform()) return () => {};

  let handle;
  let disposed = false;
  App.addListener('appUrlOpen', ({ url }) => {
    const path = normalizeDeepLinkPath(url);
    if (path) history.push(path);
  }).then((listener) => {
    if (disposed) {
      void listener.remove();
      return;
    }
    handle = listener;
  });

  return () => {
    disposed = true;
    void handle?.remove();
  };
}
